import { Dialog, DialogContent, DialogTitle, IconButton, useMediaQuery } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { TITLE_CLASS, DETAIL_CLASS } from './financial.type.component';
import RequestFinancialAdjustmentSheet from './request.financial.adjustment.sheet.component';
import AdjustmentLinkPicker from './adjustment/adjustment.link.picker.component';

const PICKER_MINIMUM_LINKS = 2;

const NARROW_SCREEN = '(max-width:600px)';

const paddingOf = (isNarrow) => ({
    title: isNarrow ? { padding: '24px 24px 0' } : { padding: '32px 40px 0' },
    content: isNarrow ? { padding: '20px 24px 28px' } : { padding: '24px 40px 40px' }
});

const targetOf = (priceInfo) =>
    [priceInfo.serviceName || priceInfo.label, priceInfo.responsibleName].filter(Boolean).join(' · ');

export default function RequestFinancialAdjustmentModal(
    { isOpen, links, priceInfo = {}, role, onSelect, onClose, onApplied, setAlert }
) {
    const isNarrow = useMediaQuery(NARROW_SCREEN);
    const padding = paddingOf(isNarrow);

    return (
        <Dialog maxWidth="md" fullWidth fullScreen={isNarrow} open={!!isOpen} onClose={onClose}>

            <DialogTitle disableTypography style={padding.title}>
                <div className="flex items-center justify-between gap-4">
                    <div>
                        <h2 className={['m-0', TITLE_CLASS].join(' ')}>Editar valores</h2>

                        {links.length < PICKER_MINIMUM_LINKS && (
                            <p className={['m-0 mt-1', DETAIL_CLASS].join(' ')}>{targetOf(priceInfo)}</p>
                        )}
                    </div>

                    <IconButton size="small" aria-label="Fechar" onClick={onClose}><Close /></IconButton>
                </div>
            </DialogTitle>

            <DialogContent style={padding.content}>
                <AdjustmentLinkPicker links={links} selectedResponsibleId={priceInfo.responsibleId} onSelect={onSelect} />

                <RequestFinancialAdjustmentSheet
                    isOpen={!!isOpen}
                    priceInfo={priceInfo}
                    role={role}
                    onClose={onClose}
                    onApplied={onApplied}
                    setAlert={setAlert}
                />
            </DialogContent>
        </Dialog>
    );
}
